// extracted by mini-css-extract-plugin
module.exports = {"root":"_511c1e","carouselImageH":"_ad5596","carouselImageV":"_37b8dd","playIcon":"_0268bb"};